import React from "react";
import Button, { ButtonSize } from "./Button";
import classes from "./comingSoon.module.scss";

interface ComingSoonButtonProps {
    label: string;
    /** What the feature will do once it ships — the tooltip. */
    description: string;
    /** Bootstrap Icons name without the `bi-` prefix. */
    icon?: string;
    size?: ButtonSize;
}

/**
 * A feature that is designed but not switched on yet (the AI helpers): a
 * disabled button tagged "Coming soon", with a tooltip saying what it will
 * do. It makes no request.
 */
const ComingSoonButton: React.FC<ComingSoonButtonProps> = ({ label, description, icon = "stars", size = "sm" }) => (
    // The wrapper carries the tooltip — a disabled button gets no hover events.
    <span className={classes.comingSoon} title={`Coming soon — ${description}`}>
        <Button type="button" variant="ghost" size={size} icon={icon} disabled aria-disabled="true">
            {label}
        </Button>
        <span className={classes.tag}>Coming soon</span>
    </span>
);

export default ComingSoonButton;
